export default "__VITE_ASSET__YPfSRbjy__"